export default Object.freeze({
  FullName: 1,
  Email: 2,
  ExtraField: 3,
  Position: 4,
  Area: 5,
});
